import { getProfile, type Role, roleMap } from "@prismicio/editor-fields"
import { FatalError } from "@prismicio/editor-support/Error"
import { preload, useRequest } from "@prismicio/editor-support/Suspense"

import { env } from "../env"
import { getRepositoryName } from "../routing"

export function useProfile() {
  return useRequest(getProfile, [
    env.USER_SERVICE_BASE_URL,
    env.PAGE_BUILDER_AUTH_STRATEGY
  ])
}

export function preloadProfile() {
  preload(getProfile, [
    env.USER_SERVICE_BASE_URL,
    env.PAGE_BUILDER_AUTH_STRATEGY
  ])
}

interface UseRoleResult {
  role: Role
  isContributor: boolean
  isWriter: boolean
  isSuperUser: boolean
}

export function useRole(locale?: string): UseRoleResult {
  const { repositories, superPower } = useProfile()

  if (superPower === true)
    return {
      role: "SuperUser",
      isContributor: false,
      isWriter: false,
      isSuperUser: true
    }

  const repositoryName = getRepositoryName()
  const repository = repositories.find(
    (repository) => repository.domain === repositoryName
  )

  if (!repository)
    throw new FatalError("User does not have access to this repository")

  let serverRole: keyof typeof roleMap = "Readonly"
  if (typeof repository.role === "string") {
    serverRole = repository.role
  } else if (locale !== undefined) {
    serverRole = repository.role[locale] ?? serverRole
  }

  const role = roleMap[serverRole]

  const isContributor = role === "Contributor"
  const isWriter = role === "Writer"

  return {
    role,
    isContributor,
    isWriter,
    isSuperUser: false
  }
}
